import PropTypes from 'prop-types';
import ArticleActionButton from '../articleActionButton';
import Icon from '../../icon';

export default function PreviewButton({ onClick, id, hasHighlight }) {
  return (
    <ArticleActionButton
      icon={<Icon.Info height={18} />}
      label="Preview"
      onClick={onClick}
      hasHighlight={hasHighlight}
      id={id}
    />
  );
}

PreviewButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  hasHighlight: PropTypes.bool,
  id: PropTypes.string.isRequired,
};

PreviewButton.defaultProps = {
  hasHighlight: false,
};
